import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled from 'styled-components';
import { scale, variant } from '@magalu/stereo-ui-styles';
import Text from '../Text';
import Flex from '../Flex';
import Box from '../Box';
export const Container = styled(Flex).attrs(_ref => {
  let {
    justifyContent,
    centered
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["justifyContent", "centered"]);

  return Object.assign({
    width: '100%',
    alignItems: 'center',
    justifyContent: centered ? 'center' : justifyContent,
    flexWrap: 'wrap',
    gap: 2,
    px: 2
  }, !(props != null && props.scale) && {
    py: 2
  }, props);
})({
  textDecoration: 'none'
}, variant, scale);
export const Title = styled(Text).attrs(_ref2 => {
  let {
    textAlign,
    centered,
    justifyContent
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["textAlign", "centered", "justifyContent"]);

  return Object.assign({
    forwardedAs: 'span',
    fontSize: 1,
    flex: centered || justifyContent !== 'space-between' ? 'unset' : 1,
    color: 'inherit',
    position: textAlign === 'center' ? 'absolute' : 'initial',
    transform: textAlign === 'center' ? 'translateX(-50%)' : 'initial',
    left: textAlign === 'center' ? '50%' : 'initial'
  }, props);
})``;
export const Content = styled(Box).attrs(props => Object.assign({
  fontSize: 1,
  color: 'text.scratched',
  fontWeight: 'regular',
  lineHeight: 'display'
}, props))({
  flexBasis: '100%',
  textAlign: 'justify',
  textAlignLast: 'left'
});